import React, { useState, useEffect } from "react";
import axios from "axios";
import { useOutletContext, Link } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
function Assessment() {
  const [userData, setUserData] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const { setGlobalLoading, token } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        setGlobalLoading(true);
        const res = await axios.get(
          `${API_BASE_URL}/employeeinfos/assessmentList/`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setUserData(res?.data?.rows);
        const departments = [
          ...new Set(
            res.data.rows.map((emp) => emp.Department).filter(Boolean)
          ),
        ];
        setDepartmentOptions(departments);
      } catch (err) {
        console.error("Error fetching data:", err);
        setUserData([]);
      } finally {
        setGlobalLoading(false);
      }
    };

    fetchEmployees();
  }, []);

  const columns = [
    {
      accessorKey: "id",
      header: "Emp_id",
      size: 150,
    },
    {
      accessorKey: "userpic",
      header: "Picture",
      size: 80,
      Cell: ({ row }) => {
        const imageUrl = row.original.userpic
          ? `https://pinepositivemoves.com/files/media/${row.original.userpic}`
          : "https://smarthr.dreamstechnologies.com/html/template/assets/img/users/user-39.jpg";

        return (
          <img
            src={imageUrl}
            alt="Profile"
            style={{
              width: "35px",
              height: "35px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/default-profile.png";
            }}
          />
        );
      },
    },
    {
      accessorKey: "Fullname",
      header: "Name",
      size: 150,
      Cell: ({ row }) => (
        <Link
          to={`/employeeinfo/view/${row.original.id}`}
        >
          {row.original.Fullname || row.original.username}
        </Link>
      ),
    },
    {
      accessorKey: "Designation",
      header: "Designation",
      size: 130,
    },
    {
      accessorKey: "Department",
      header: "Department",
      size: 130,
      filterVariant: "select",
      filterSelectOptions: departmentOptions,
    },

    {
      accessorKey: "Level",
      header: "Level",
      size: 100,
      Cell: ({ cell }) => cell.getValue() || "NA",
    },
    {
      accessorKey: "Worklocation",
      header: "Location",
      size: 140,
    },
    {
      accessorKey: "status",
      header: "Status",
      size: 80,
      filterVariant: "select",
      filterSelectOptions: ["active", "inactive"],
      Cell: ({ cell }) => (
        <span
          style={{
            backgroundColor: cell.getValue() === "active" ? "green" : "red",
            color: "white",
            padding: "3px 8px",
            borderRadius: "12px",
            fontSize: "0.8rem",
          }}
        >
          {cell.getValue()}
        </span>
      ),
    },
  ];

  return (
    <div className="content">
      <div className="card">
        <div className="card-header d-flex align-items-center justify-content-between flex-wrap">
          <h5>Employees Assessment</h5>
        </div>

        <div className="card-body">
          {userData.length === 0 ? (
            <p className="text-muted">No employees found.</p>
          ) : (
            <MaterialReactTable
              columns={columns}
              data={userData}
              enableColumnOrdering
              enableFilters // enables filtering UI
              initialState={{
                pagination: { pageSize: 50 },
                columnFilters: [{ id: "status", value: "active" }], // default to active employees
              }}
              muiTableBodyCellProps={{
                sx: {
                  padding: "8px 10px",
                },
              }}
              muiTableHeadCellProps={{
                sx: {
                  backgroundColor: "#f5f5f5",
                  fontWeight: "bold",
                },
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Assessment;
